import React, { Component } from 'react'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CommonActionUI from './CommonActionUI.js'

class CacheDeleteSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      submitted: false,
      successMsg: null,
      errorList: null
    }
  }

  render() {
    return (
      <CommonActionUI
        context={this.props.context}
        title='Delete cache'
        buttonLabel='Delete'
        submitted={this.state.submitted}
        onClick={this.onClick}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
      />
    )
  }

  onClick = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return
    this.setState({submitted: true})

    RestApiUtils.delete(this.props.context,
      `/api/system/cache`,
      this.onPostCallback, {}
    )
  }

  onPostCallback = (response) => {
    this.setState({
      submitted: false,
      successMsg: response.success,
      errorList: response.errorList
    })

    setTimeout(() => { this.setState({successMsg: null})}, 2000)
  }
}

export default CacheDeleteSF
